import { get, isEmpty } from 'lodash';
import moment from 'moment';

import { helperProps } from 'common/types/index';

import { countryCodeList } from './optionList';

const validateUser = ({ role }: helperProps) => {
  const isRoleAdmin = role === 'ADMIN';
  return isRoleAdmin ? '/dashboard' : '/startup/navigate';
};

const constructArray = (payload: any = []) => {
  const response = payload.map((i: any) => {
    return {
      text:
        i.ycBatchName ||
        i.location ||
        i.industryType ||
        i.country ||
        i.state ||
        i.ycLocation,
      value:
        i.ycBatchName ||
        i.location ||
        i.industryType ||
        i.country ||
        i.state ||
        i.ycLocation,
    };
  });
  return response;
};

const messageHelper = (message: string, constant: string, include: string) =>
  message.includes(include) ? constant : message;

const errorMessageHandler = (err: any) => {
  // later sentry integration purposes
  return get(err, 'response.data.message') || get(err, 'message');
};

const removeDuplicates = (payload: any, prop: string) => {
  const newArray = [];
  const lookupObject: any = {};

  for (const i in payload) {
    if (payload[i] && payload[i][prop]) {
      lookupObject[payload[i][prop]] = payload[i];
    }
  }

  for (const i in lookupObject) {
    newArray.push(lookupObject[i]);
  }
  return newArray;
};

// FORMAT AMOUNT WITH CURRENCY SYMBOL
const formatAmount = (amount: number, options?: any) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  });
  return formatter.format(amount);
};

// FORMAT AMOUNT WITHOUT CURRENCY SYMBOL
const formatMoney = (amount: any = 0) => {
  const dollarUSLocale = Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return dollarUSLocale.format(parseFloat(amount));
};

// FORMAT AMOUNT WITH TEXT FORMAT
const convertAmountIntoReadableFormat = (amount: any = 0) => {
  // Nine Zeroes for Billions
  return Math.abs(Number(amount)) >= 1.0e9
    ? (Math.abs(Number(amount)) / 1.0e9).toFixed(0) + ' Billion'
    : // Six Zeroes for Millions
    Math.abs(Number(amount)) >= 1.0e6
    ? (Math.abs(Number(amount)) / 1.0e6).toFixed(0) + ' Million'
    : // Three Zeroes for Thousands
    Math.abs(Number(amount)) >= 1.0e3
    ? (Math.abs(Number(amount)) / 1.0e3).toFixed(0) + ' Thousand'
    : Math.abs(Number(amount)).toFixed(0);
};

const getNavTotal = (
  navTrackData: any,
  portfolioCardData: any,
  selectedNav: boolean,
) => {
  if (!isEmpty(navTrackData)) {
    const sorted = navTrackData.sort(sortByDate);
    const lastIndex = sorted.length - 1;
    return selectedNav
      ? parseFloat(get(sorted, `[${lastIndex}].nav`, 0))
      : parseFloat(get(sorted, `[${lastIndex}].nav`, 0)) +
          parseFloat(get(sorted, `[${lastIndex}].distribution`, 0));
  } else if (!isEmpty(portfolioCardData)) {
    return selectedNav
      ? get(portfolioCardData, 'totalAssetValue', 0)
      : get(portfolioCardData, 'totalAssetValue', 0) +
          get(portfolioCardData, 'comulativeDistribution', 0);
  }

  return 0;
};

const getNavTotalLatestDate = (navTrackData: any, investmentDate: string) => {
  if (!isEmpty(navTrackData)) {
    const sorted = navTrackData.sort(sortByDate);
    const newSortedTrack = sorted.filter((navTrack: any) => {
      if (!moment(get(navTrack, 'date')).isBefore(investmentDate))
        return navTrack;
    });
    const lastIndex = newSortedTrack.length - 1;
    return get(newSortedTrack, `[${lastIndex}].date`, investmentDate);
  } else {
    return investmentDate;
  }
};

// SHORTING BY DATE ASC ORDER
const sortByDate = (a: any, b: any) => {
  if (a.date < b.date) {
    return -1;
  }
  if (a.date > b.date) {
    return 1;
  }
  return 0;
};

export {
  countryCodeList,
  validateUser,
  messageHelper,
  constructArray,
  errorMessageHandler,
  removeDuplicates,
  formatAmount,
  formatMoney,
  convertAmountIntoReadableFormat,
  sortByDate,
  getNavTotal,
  getNavTotalLatestDate,
};
